<template>
  <a-modal :visible="showDialog"  :mask="true" :maskClosable="false" title="用户组授权" @ok="handleOk" @cancel="handleCancel()">
   <a-form layout="vertical">
     <a-form-item label="">
       <a-tree
          v-model="groupInfo.auth"
          checkable
          defaultExpandAll
          :defaultSelectedKeys="groupInfo.auth2"
          :auto-expand-parent="autoExpandParent"
          :tree-data="menuList"
          :checkedKeys="businessSelectedRowKeys"
          @check="onCheck"
        />
     </a-form-item>
   </a-form>
  </a-modal>
</template>
<script>
import {GroupAuth} from "../../api/v1/group_api";

export default {
  name: "GroupAuthDialog",
  props:['groupInfo','showDialog','menuList','type'],
  data(){
    return {
      autoExpandParent:true,
      businessSelectedRowKeys:[],
      allSelectedNodes:[]
    }
  },
  methods:{
    handleOk(){
      let auth
      auth = this.allSelectedNodes
      let data
      if (this.type == 'oldgb') {
        data = {
          "id":this.groupInfo.id,
          "oldgb_auth":auth
        }
      } else {
        data = {
          "id":this.groupInfo.id,
          "auth":auth
        }
      }
      GroupAuth(data).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.$emit('close-dialog')
    },
    onCheck(selectedKeys, e) {
      // 已勾选子节点以及半勾选状态的父节点
      this.allSelectedNodes = selectedKeys.concat(e.halfCheckedKeys);
      this.userInfo.auth = selectedKeys;
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/GroupAuthDialog.vue